<template>
  <parent>
    <loading-page v-if="gettingOrganization" />
    <div v-else>
      <h1 class="text-main">
        {{ organization.name }}
      </h1>

      <b-tabs class="mt-2">
        <b-tab
          title="Overview"
          :active="routeName === 'billing'"
          @click="changeView('billing')"
        />
        <b-tab
          title="Payments"
          :active="routeName === 'payments'"
          @click="changeView('payments')"
        />
        <b-tab
          title="Invoices"
          :active="routeName === 'billing-invoices'"
          @click="changeView('billing-invoices')"
        />
      </b-tabs>
      <transition
        name="fade"
        mode="out-in"
      >
        <router-view
          :key="$route.path"
          class="mt-2 container"
        />
      </transition>
    </div>
  </parent>
</template>
<script>
import redirectError from '@/services/redirectError'

export default {
  name: 'Billing',
  data() {
    return {
      fields: [
        'funding',
        { key: 'last4', label: 'Card Number' },
        { key: 'exp_date', label: 'Expiration Date' },
        'brand',
        'country',
      ],
      showEditor: false,
      errorMessage: null,
      loading: true,
    }
  },
  computed: {
    organization() {
      return this.$store.state.organization.organization
    },
    gettingOrganization() {
      return this.$store.state.organization.gettingOrganization
    },
    organizationId() {
      return this.$store.state.app.organizationId
    },
    routeName() {
      return this.$route.name
    },
  },
  created() {
    this.$store.dispatch('organization/getOrganization', this.organizationId)
      .catch(err => redirectError(err, this.$router, this.$route.path))
  },
  methods: {
    changeView(view) {
      this.$router.push({ name: view }).catch(() => {})
    },
  },
}
</script>
